import {
  FETCH_COLLECTIONS_REQUEST,
  FETCH_COLLECTIONS_SUCCESS,
  FETCH_COLLECTIONS_FAILURE,
  ADD_COLLECTION_REQUEST,
  ADD_COLLECTION_SUCCESS,
  ADD_COLLECTION_FAILURE,
  UPDATE_COLLECTION_REQUEST,
  UPDATE_COLLECTION_SUCCESS,
  UPDATE_COLLECTION_FAILURE,
  DELETE_COLLECTION_REQUEST,
  DELETE_COLLECTION_SUCCESS,
  DELETE_COLLECTION_FAILURE,
  SET_COLLECTION_EDIT,
  CLEAR_COLLECTION_EDIT,
} from '../../../../types/masters/styles/collection/collectionTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingCollection: null,
};

const collectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COLLECTIONS_REQUEST:
    case ADD_COLLECTION_REQUEST:
    case UPDATE_COLLECTION_REQUEST:
    case DELETE_COLLECTION_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_COLLECTIONS_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_COLLECTION_SUCCESS:
    case UPDATE_COLLECTION_SUCCESS:
    case DELETE_COLLECTION_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_COLLECTIONS_FAILURE:
    case ADD_COLLECTION_FAILURE:
    case UPDATE_COLLECTION_FAILURE:
    case DELETE_COLLECTION_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_COLLECTION_EDIT:
      return { ...state, editingCollection: action.payload };
    case CLEAR_COLLECTION_EDIT:
      return { ...state, editingCollection: null };
    default:
      return state;
  }
};

export default collectionReducer; 